/**
 * Generic content skeletons for the staff shell's first frame, used where the
 * route's own page skeleton is not known (or not worth loading yet).
 *
 * Boards are not drawn generically: each board's own skeleton (Production,
 * Supplier Orders, a supplier's board) is drawn from its page's pieces so the
 * first frame matches it exactly — see `DashboardRouteSkeleton`.
 */
import { Skeleton } from "@/components/ui/skeleton";

import { CanvasSkeleton, SkeletonPanel } from "./SkeletonBlocks";

/** A page title and one content panel — neutral enough for any staff page. */
export function PageContentSkeleton() {
  return (
    <div className="flex w-full flex-col gap-5" aria-hidden>
      <div className="flex flex-col gap-2">
        <CanvasSkeleton className="h-8 w-56 max-w-full" />
        <CanvasSkeleton className="h-4 w-80 max-w-full" />
      </div>
      <SkeletonPanel className="flex flex-col gap-3 p-4">
        <Skeleton className="h-9 w-full max-w-md" />
        {Array.from({ length: 6 }, (_, index) => (
          <Skeleton key={index} className="h-10 w-full" />
        ))}
      </SkeletonPanel>
    </div>
  );
}
